module.exports = __webpack_public_path__ + "static/media/DINNextLTProLight.2354d950.woff";